import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { isNonEmptyString, isNotNull } from '../../util/check';

/**
 * This Component is a type of secondary navigation scheme that reveals
 * the users location in a website or Web application on the top of page.
 * And show a hierarchy of the current location as well.
 */
@Component({
  selector: 'fn-breadcrumb',
  templateUrl: './fn-breadcrumb.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FnBreadcrumbComponent implements OnInit {
  @Input() menuItemArray: Array<any> = [];
  @Input() setMenuItemSub: Subject<Array<any>>;
  @Input() customMenuSub: Subject<string>;
  uiMenuItemArray: Array<any>;
  @Output() menuClickEvent = new EventEmitter<any>();
  private totalNoOfMenu = 0;


  uiMap = {
    isShowCustomMenu: false,
    customMenuText: ''
  }

  /**
   * Creates an instance of fn breadcrumb component.
   */
  constructor() { }

  /**
   * Implements ngOnInit event handler.
   */
  ngOnInit() {
    this.buildUiMenu();
    if (this.setMenuItemSub) {
      this.setMenuItemSub.subscribe((menuItemArray) => {
        this.menuItemArray = menuItemArray;
        this.buildUiMenu();
      });
    }

    if (this.customMenuSub) {
      this.customMenuSub.subscribe(menuText => {
        this.uiMap.isShowCustomMenu = isNotNull(menuText) && isNonEmptyString(menuText);
        this.uiMap.customMenuText = menuText;
      })
    }
  }

  buildUiMenu() {
    this.uiMenuItemArray = this.menuItemArray.filter((obj) => {
      return !(obj.id.endsWith('_Global') || obj.id.endsWith('_Site'));
    });
    this.totalNoOfMenu = this.uiMenuItemArray.length - 1;
  }

  breadCrumbClick(menu: any, index: number) {
    if (index != this.totalNoOfMenu || this.uiMap.isShowCustomMenu) {
      this.menuClickEvent.emit(menu);
    }
  }

}
